import { useQuery } from "@tanstack/react-query";
import React from "react";
import { NavLink } from "react-router-dom";
import Loader from "../../../components/loader/Loader";
import axiosaim from "../../../api/axiosaim";
import '../leaves.scss';
import Departments from "../../../components/leave/requests/Department";
import AllRequests from "../../../components/leave/requests/AllRequests";

const Requests = () => {
    const aimtoken = sessionStorage.getItem('aimtoken') || '';
    const departmentslug = sessionStorage.getItem('departmentslug') || '';
    const uname = sessionStorage.getItem('uname');

    const { data: manageddepartments, isLoading: isLoadingDepartments } = useQuery({
        queryKey: ['managedAIMDepartments', uname],
        queryFn: async () => {
            const res = await axiosaim.get(`getmanageddepartments`, {
                headers: { 'X-Aim-Token': aimtoken }
            });
            return res.data;
        },
        enabled: !!uname && !!aimtoken,
        retry: 1
    });

    return (
        <div className="leave leave-requests">
            <div className="page-header">
                <div className='title'>
                    <h1>Leave Requests</h1>
                    <ul className='breadcrumbs'>
                        <li>
                            <NavLink to='/leaves/my-leave'>Leave</NavLink>
                        </li>
                        <li>
                            <span>Requests</span>
                        </li>
                    </ul>
                </div>
            </div>

            { isLoadingDepartments
                ? (
                    <div className="columns">
                        <Loader />
                    </div>
                )
                : manageddepartments?.length > 1
                    ? (
                        <Departments departments={manageddepartments} loading={isLoadingDepartments} />
                    ) : (
                        <AllRequests departmentslug={departmentslug} />
                    )
            }

        </div>
    )
}

export default Requests;